import { useCallback, useEffect, useState } from 'react';
import type { DesktopUpdateState } from '@mailpilot/shared';
import { bridge } from '../lib/desktop';

/** Live in-app update state from the desktop shell; `supported` is false in the browser or older desktop builds. */
export function useDesktopUpdates() {
  const b = bridge();
  const supported = !!b?.getUpdateState;
  const [state, setState] = useState<DesktopUpdateState | null>(null);
  useEffect(() => {
    if (!b?.getUpdateState) return;
    let off: (() => void) | undefined;
    b.getUpdateState().then(setState).catch(() => undefined);
    try {
      off = b.onUpdateState?.(setState);
    } catch {
      /* ignore */
    }
    return () => off?.();
  }, [b]);
  const check = useCallback(async () => {
    if (b?.checkForUpdates) setState(await b.checkForUpdates());
  }, [b]);
  const download = useCallback(async () => {
    if (b?.downloadUpdate) setState(await b.downloadUpdate());
  }, [b]);
  const install = useCallback(async () => {
    await b?.installUpdate?.();
  }, [b]);
  return { supported, state, check, download, install, appVersion: b?.appVersion ?? null };
}
